import { useEffect } from "react";
import { useParams } from "react-router-dom";
import PreviewArticleComp from "../../Components/Articles/PreviewArticle";
import { useArticle } from "../../hooks/apis/useArticle";
import ScrollToTop from "../../Components/ScrollToTop";
import { handleGainSightEventForPageNotFound } from "../../gainSightIntegration";
import useNavigateWithSearch from "../../Context/KBContext/hooks/useNavigateWithSearch";
import { ArticleLoader } from "../../Components/Loaders/Article";

export default function PreviewArticle() {
  const { categorySlug: pathCategorySlug, articleSlug } = useParams();
  const navigate = useNavigateWithSearch();
  const { data: selectedArticle, error, isLoading } = useArticle({ articleSlug });

  useEffect(() => {
    if( !error ){
      return;
    }
    // handle if article api fails
    if( error?.response?.status === 404 ){
      handleGainSightEventForPageNotFound(window.location.href);
    }
    navigate("/not-found");
  }, [ error, navigate ]);

  useEffect(() => {
    if( !selectedArticle?.fullPath ){
      return;
    }
    const categorySlug = selectedArticle.fullPath.split('/').at(-2);
    if( categorySlug && pathCategorySlug !== categorySlug ){
      navigate(`/${categorySlug}/${articleSlug}`, { replace: true });
    }
  }, [ pathCategorySlug, articleSlug, selectedArticle, navigate ]);

  if (isLoading) {
    return (
      <>
        <ScrollToTop />
        <ArticleLoader />
      </>
    );
  }

  if (!selectedArticle) {
    return null;
  }

  return (
    <>
      <ScrollToTop />
      <PreviewArticleComp
        selectedArticle={selectedArticle}
      />
    </>
  );
}
